import type { IconData } from "./types";

export const Google: IconData = [
	{
		d: "M 21.39 8.685 L 20.52 8.685 L 20.52 8.64 L 10.8 8.64 L 10.8 12.96 L 16.904 12.96 C 16.013 15.475 13.62 17.28 10.8 17.28 C 7.221 17.28 4.32 14.379 4.32 10.8 C 4.32 7.221 7.221 4.32 10.8 4.32 C 12.452 4.32 13.955 4.943 15.099 5.961 L 18.154 2.906 C 16.225 1.109 13.645 0 10.8 0 C 4.836 0 0 4.836 0 10.8 C 0 16.764 4.836 21.6 10.8 21.6 C 16.764 21.6 21.6 16.764 21.6 10.8 C 21.6 10.076 21.525 9.369 21.39 8.685 Z",
		transform: "translate(1.2 1.2)",
	},
	{
		d: "M 1.35 5.773 L 4.898 8.375 C 5.858 5.998 8.184 4.32 10.905 4.32 C 12.557 4.32 14.059 4.943 15.204 5.961 L 18.258 2.906 C 16.33 1.109 13.749 0 10.905 0 C 6.756 0 3.159 2.342 1.35 5.773 Z",
		transform: "translate(1.2 1.2)",
	},
	{
		d: "M 10.695 21.571 C 13.484 21.571 16.019 20.503 17.936 18.767 L 14.593 15.939 C 13.472 16.791 12.103 17.252 10.695 17.251 C 7.886 17.251 5.5 15.46 4.602 12.96 L 1.08 15.673 C 2.867 19.171 6.497 21.571 10.695 21.571 Z",
		transform: "translate(1.2 1.2)",
	},
	{
		d: "M 21.39 8.685 L 20.52 8.685 L 20.52 8.64 L 10.8 8.64 L 10.8 12.96 L 16.904 12.96 C 16.478 14.157 15.71 15.203 14.697 15.968 L 14.698 15.967 L 18.041 18.796 C 17.804 19.011 21.6 16.2 21.6 10.8 C 21.6 10.076 21.525 9.369 21.39 8.685 Z",
		transform: "translate(1.2 1.2)",
	},
];

export const Inflect: IconData = [
	{
		d: "M 9.375 13.688 L 3 19.125 L 10.875 15.563 Z M 9.938 13.125 L 20.25 3.375 C 21.125 4.812 21.488 8.962 15.938 14.063 L 15.938 20.813 Z M 11.625 10.125 L 14.813 7.313 L 8.25 6.75 Z",
	},
];

export const Kakao: IconData = [
	{
		d: "M 4.86 15.12 L 4.32 19.98 L 9.72 16.2 Z",
		transform: "translate(1.2 1.8)",
	},
	{
		d: "M 0 8.64 C 0 3.868 4.835 0 10.8 0 C 16.765 0 21.6 3.868 21.6 8.64 C 21.6 13.412 16.765 17.28 10.8 17.28 C 4.835 17.28 0 13.412 0 8.64 Z",
		transform: "translate(1.2 1.8)",
	},
];

export const Naver: IconData = [
	{
		d: "M 15.434 21.864 L 8.479 11.626 L 8.479 21.864 L 1.2 21.864 L 1.2 2.1 L 8.587 2.1 L 15.542 12.317 L 15.542 2.1 L 22.8 2.1 L 22.8 21.864 Z",
	},
];
